export const getIsStudioSiteQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const response = await httpClient.post('/_api/premium-package-pickers-api/get-is-studio-site', {
    siteGuid: request.siteGuid
  });
  return response.data;
};
//# sourceMappingURL=get-is-studio-site.query.js.map